<template lang="pug">
div
  header.nav-header(:class="navColorClass")
    .content
      a.logo(:href="homeLink")
        img(:src="logo" alt="Kezzler")
        |
        span {{title}}
      nav.nav
        MobileIcon(ref="mobileMenu", @show="hideUserMenu()")
        ul.main-menu
          NavItem(v-for="(p, i) in availableItems" :item="p" :key="i")
      nav.secondary-menu
        .switch-icon(
            :class="{ 'active': activeCover=='Switchsite' }"
            title="Kezzler Services"
            @click="toggle('Switchsite')"
          )
          span(v-for="dot in [1,2,3,4,5,6,7,8,9]" :key="dot")
        .search-icon(
            :class="{ 'active':  activeCover=='Search' }"
            title="Search"
            @click="toggle('Search')"
          )
          <svg width="24" height="24" viewBox="0 0 24 24"><g class="svg-color" fill="#FFF" fill-rule="evenodd"><path d="M15.87 14.8l6.26 6.27-1.06 1.06-6.26-6.26C13.25 17.2 11.23 18 9 18c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9c0 2.22-.8 4.24-2.13 5.8zM9 16.5c4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5z"/><circle cx="22" cy="22" r="1.5"/><circle cx="14.75" cy="14.75" r="1.5"/></g></svg>
        .user-menu(:title=username, :class="{ active: userMenuVisible }", @click="toggleUserMenu()")
          a#user-icon(:style="{backgroundColor: usernameBgColor}") {{usernameFirstLetter}}
          ul.sub-menu
            li
              router-link(:to="{name: 'userPreferences'}") {{username}}
            li
              router-link(:to="{name: 'runAs'}" v-visible-for="['ROLE_RUNAS', 'ROLE_RUNAS_READONLY']") Run As...
            li
              a(@click="logout()") Log out
  NavCoverPage(:current="activeCover" @close="activeCover=null")
</template>
<script>
import Util from '@/service/Util'
import NavItem from './NavItem'
import MobileIcon from './MobileIcon'
import NavCoverPage from './NavCoverPage'
import auth from '../../service/AuthService'

function isMenuItemVisibleForUser(item) {
  // if not marked with visibleFor, then always visible
  if (!item.visibleFor) {
    return true
  }

  // admin user - all items visible
  // TODO: check this with new server changes for ROLE_ADMIN
  if (auth.isAdmin()) {
    return true
  }

  // check item.visibleFor array which should be in this format ['ROLE_ORDER_MANAGER', 'ROLE_CODE_MANAGER']
  return item.visibleFor.some((r) => auth.hasRole(r))
}

const colors = [
  '#004fe1', '#0061e1', '#0082c1', '#009c93',
  '#00b175', '#00974e', '#c9aa00', '#d38600',
  '#ce5700', '#ce0000', '#ce0044', '#ce0083',
  '#b600c1', '#8d0ccf', '#7314d8', '#1b2fc3'
]

export default {
  name: 'SspNav',
  props: ['title', 'pages', 'homeLink', 'navColorClass'],
  data() {
    return {
      userMenuVisible: false,
      username: auth.getUsername(),
      activeCover: null,
      logo: require('kezzler-app-design/src/assets/kezzler-logo-white@1x.png')
    }
  },
  components: {
    NavItem,
    MobileIcon,
    NavCoverPage
  },
  methods: {
    logout() {
      auth.logout(() => {
        this.$router.push('/')
      })
    },
    toggle(cover) {
      this.activeCover = this.activeCover === cover ? null : cover
    },
    toggleUserMenu() {
      this.userMenuVisible = !this.userMenuVisible
      if (this.$refs.mobileMenu) {
        this.$refs.mobileMenu.hideMenu()
      }
    },
    hideUserMenu() {
      this.userMenuVisible = false
    }
  },
  computed: {
    availableItems() {
      const pages = this.pages || []
      const filtered = pages
        .map((p) => { // remap with filtered sub-items
          const sub = {
            id: p.id,
            title: p.title,
            sub: p.sub && p.sub.filter(isMenuItemVisibleForUser)
          }
          return sub
        })
        .filter((p) => p.sub && p.sub.length > 0) // filter out empty top level menus
      return filtered
    },
    usernameFirstLetter() {
      return this.username.charAt(0).toUpperCase()
    },
    usernameBgColor() {
      return colors[Util.hashMod(this.username, colors.length)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nav/SspNav.vue